module.exports = __webpack_public_path__ + "img/hiw-5.81ca3eb0.svg";